export const PXIntegrationCards = (function () {
	'use strict';

	function init() {
		const filterEls = document.querySelectorAll('[js-integration-filter]')
		const selectEl = document.querySelector('[js-integration-select]')
		const cardEls = document.querySelectorAll('[js-integration-category]')
		const moreLess = document.querySelector('[js-integration-more-less]')
		if (!filterEls.length || !cardEls.length) {
			return
		}
		const maxShow = 10
		let showAll = false
		let active = 'all'

		const setActive = (slug) => {
			if (slug === active) {
				return
			} else {
				active = slug
			}
			filterEls.forEach(filter => {
				filter.classList.toggle('active', filter.getAttribute('js-integration-filter') === active)
			})
			selectEl.value = slug
			updateCards()
		}

		const updateCards = () => {
			let count = 0
			cardEls.forEach(card => {
				const cat = card.getAttribute('js-integration-category')
				const isActive = active === 'all' || active === cat
				if (isActive) {
					count++
				}
				const inCount = isActive && (count <= maxShow || showAll)
				card.classList.toggle('show', isActive && inCount)
			})
			moreLess.classList.toggle('show', count > maxShow)
		}

		moreLess.addEventListener('click', event => {
			showAll = !showAll
			moreLess.textContent = showAll ? 'See less' : 'See more'
			moreLess.classList.toggle('less', showAll)
			moreLess.classList.toggle('more', !showAll)
			updateCards()
		})

		selectEl.addEventListener('change', event => {
			const opts = event.target.options
			setActive(opts[opts.selectedIndex].value)
		})

		filterEls.forEach(button => {
			const slug = button.getAttribute('js-integration-filter')
			button.addEventListener('click', event => {
				setActive(slug)
			})
		})

		updateCards()
	}

	return {
		init: init
	};
})();
